import { Component, Input, OnInit } from '@angular/core';
import { IForm, ItemType, LabelLocation } from '../../../base/src/abcForm/abcForm';

@Component({
    selector: '',
    template: `<div class="devExFormStyle">
      <dx-form
        [formData]="formData"
        [visible]="visible"
        [height]="height"
        [width]="width"
        [class]="class"
        [activeStateEnabled]="activeStateEnabled"
        [alignItemLabels]="alignItemLabels"
        [disabled]="disabled"
        [hoverStateEnabled]="hoverStateEnabled"
        [showOptionalMark]="showOptionalMark"
        [optionalMark]="optionalMark"
        [readOnly]="readOnly"
        [requiredMark]="requiredMark"
        [showRequiredMark]="showRequiredMark"
        [rtlEnabled]="rtlEnabled"
        [scrollingEnabled]="scrollingEnabled"
        [showColonAfterLabel]="showColonAfterLabel"
        [showValidationSummary]="showValidationSummary"
        [tabIndex]="tabIndex"
        [minColWidth]="minColWidth"
        [labelLocation]="labelLocation"
        >
        @if (itemType) {
          <dxi-form-item
            #dxItem
            [itemType]="itemType"
            [caption]="caption"
            [id]="id"
            [height]="height"
            [width]="width"
          ></dxi-form-item>
        }
      </dx-form>
    </div>`,
    styleUrls: ['./devExForm.component.scss'],
    standalone: false
})

//       [requiredMessage]="requiredMessage"
export class DevExFormComponent implements OnInit {
  htmlAttributes: IForm;
  @Input() id: string;
  @Input() caption: string;
  @Input() itemType: ItemType;
  @Input() height: string | number;
  @Input() width: string | number;
  @Input() formData: any;
  @Input() visible: boolean = true;
  @Input() activeStateEnabled: boolean;
  @Input() alignItemLabels: boolean;
  @Input() disabled: boolean;
  @Input() hoverStateEnabled: boolean;
  @Input() labelLocation: LabelLocation = LabelLocation.Left;
  @Input() minColWidth: number;
  @Input() showOptionalMark: boolean;
  @Input() optionalMark: string;
  @Input() readOnly: boolean;
  @Input() requiredMark: string;
  @Input() requiredMessage: string;
  @Input() showRequiredMark: boolean;
  @Input() rtlEnabled: boolean = false;
  @Input() scrollingEnabled: boolean;
  @Input() showColonAfterLabel: boolean;
  @Input() showValidationSummary: boolean;
  @Input() tabIndex: number;
  @Input() class: string;

  constructor() {}

  ngOnInit(): void {}
}
